/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
 
import { useStyles } from './styles';
import useCommonStores from '../../store/useCommonStores';
import useFields from './useFields';

function SubscribersFields (props) {
    const {
        widget,
        widgetTheme,
    } = useCommonStores();

    const classes = useStyles({
        widget,
        widgetTheme,
    });
  
    const {
        renderFields,
        renderCustomFields,
        renderOptins,
    } = useFields({
        classes,
    });
 
    return (
        <React.Fragment>
            
            <div className={classes.formFields}>
                { renderFields() }
                { renderCustomFields() }
                { renderOptins() }
            </div>
            
        </React.Fragment>
    );
}

SubscribersFields.propTypes = {
    transate: PropTypes.func,
};

export default observer(SubscribersFields);